<template>
  <div id="about">
    <div class="ptob py-4">
      <h2 class="text-white" data-aos="fade-down">{{ $t('about1') }}</h2>
      <img class="logo-w" src="./../assets/images/OMNI_logo_W.png" data-aos="fade-down" data-aos-delay="300">
    </div>

    <div class="img-with-text">
      <img id="img1" class="w-100" src="./../assets/images/about_1.jpg">
      <div id="text1" class="text-on-img text-white" data-aos="fade-right">
        <h3 class="text-white mb-5">{{ $t('about2') }}{{ $t('about3') }}</h3>
        <p class="text-white">{{ $t('about4') }}</p>
      </div>
    </div>

    <div class="ptob py-4">
      <img class="logo-w" src="./../assets/images/OMNI_logo_W.png" data-aos="fade-down">
      <h2 class="text-white" data-aos="fade-down" data-aos-delay="300">{{ $t('develop') }}</h2>
    </div>

    <div id="history" class="btob py-4">
      <div class="row justify-content-center px-5">
        <div class="col-5 lg"></div>
        <div class="col-lg-5 col-md-10 ps-5 vline text-start">
          <!-- 2016 -->
          <div class="position-relative mt-4">
            <h3 class="text-purple text-start mb-0" data-aos="fade-left">{{ $t('2016a') }}</h3>
            <h3 class="text-purple text-start mb-3" data-aos="fade-left">{{ $t('2016b') }}</h3>
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">{{ $t('2016c') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2016d') }}</p>
            <img id="img2016" class="time-img-left" src="./../assets/images/time_pic_1.png" data-aos="flip-right">
          </div>
          <!-- 2018 -->
          <div class="position-relative mt-4">
            <h3 class="text-purple text-start mb-0" data-aos="fade-left">{{ $t('2018a') }}</h3>
            <h3 class="text-purple text-start mb-3" data-aos="fade-left">{{ $t('2018b') }}</h3>
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">{{ $t('2018c') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2018d') }}</p>
            <img id="img2018" class="time-img-left" src="./../assets/images/time_pic_2.png" data-aos="flip-right">

            <h5 class="text-purple text-start time-dot-left mt-3" data-aos="fade-left">{{ $t('2018e') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2018f') }}</p>

            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">{{ $t('2018g') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2018h') }}</p>
          </div>
          <!-- 2019 -->
          <div class="position-relative mt-4">
            <div class="time-text-left w-100" data-aos="fade-right">
              <h3 class="text-purple mb-0">{{ $t('2019a') }}</h3>
              <h3 class="text-purple mb-3">{{ $t('2019b') }}</h3>
              <h5 class="text-purple time-dot-right">{{ $t('2019c') }}</h5>
              <p class="text-gray">{{ $t('2019d') }}</p>
            </div>
            <img id="img2019_1" class="mt-3" src="./../assets/images/time_pic_3.png" data-aos="flip-left">
            <div class="time-text-left w-100" data-aos="fade-right">
              <h5 class="text-purple time-dot-right">{{ $t('2019e') }}</h5>
              <p class="text-gray">{{ $t('2019f') }}<br>
              {{ $t('2019g') }}</p>
              <h5 class="text-purple time-dot-right">{{ $t('2019h') }}</h5>
              <p class="text-gray">{{ $t('2019i') }}<br>
              {{ $t('2019j') }}</p>
              <h5 class="text-purple time-dot-right">{{ $t('2019k') }}</h5>
              <p class="text-gray">{{ $t('2019l') }}</p>
            </div>
            <img id="img2019_2" class="mt-3" src="./../assets/images/time_pic_4.png" data-aos="flip-left">
          </div>
          <!-- 2020-->
          <div class="position-relative mt-4">
            <h3 class="text-purple text-start mb-0" data-aos="fade-left">{{ $t('2020a') }}</h3>
            <h3 class="text-purple text-start mb-3" data-aos="fade-left">{{ $t('2020b') }}</h3>
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">{{ $t('2020c') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2020d') }}<br>
            {{ $t('2020e') }}<br>
            {{ $t('2020f') }}</p>
            <img id="img2020_1" class="time-img-left" src="./../assets/images/time_pic_5.png" data-aos="flip-right">

            <h5 class="text-purple text-start time-dot-left mt-3" data-aos="fade-left">{{ $t('2020g') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2020h') }} {{ $t('2020i') }}</p>

            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">{{ $t('2020j') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2020k') }} {{ $t('2020l') }}
            <br style="font-size: 0.5rem">{{ $t('2020m') }}</p>
          </div>
          <div class="position-relative mt-4">
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">{{ $t('2020n') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2020o') }} {{ $t('2020p') }}</p>
            <img id="img2020_2" class="time-img-left" src="./../assets/images/time_pic_6.png" data-aos="flip-right">
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">{{ $t('2020q') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2020r') }}</p>
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">{{ $t('2020s') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2020t') }}
            <br>{{ $t('2020u') }}</p>
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">{{ $t('2020v') }}</h5>
            <p class="text-gray text-start" data-aos="fade-left">{{ $t('2020w') }}</p>
          </div>
          <!-- 2021-->
          <div class="position-relative mt-4">
            <div class="time-text-left w-100" data-aos="fade-right">
              <h3 class="text-purple mb-0">{{ $t('2021a') }}</h3>
              <h5 class="text-purple time-dot-right">{{ $t('2021b') }}</h5>
              <p class="text-gray">{{ $t('2021c') }}</p>
              <h5 class="text-purple time-dot-right">{{ $t('2021d') }}</h5>
              <p class="text-gray">{{ $t('2021e') }}</p>
            </div>
            <img id="img2021" class="mt-3" src="./../assets/images/time_pic_7.png" data-aos="flip-left">
          </div>
          <!-- 2022 (文右圖左) -->
          <div class="position-relative mt-4 timeline-item is-right-text">
            <h3 class="text-purple text-start mb-0" data-aos="fade-left">2022</h3>
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">2022/3</h5>
            <p class="text-gray text-start" data-aos="fade-left">
              在台灣取得專利授權<br>專利編號：I756681
            </p>

            <img id="img2022" class="shadow-sm timeline-img is-left" src="./../assets/images/I859934.jpg" data-aos="flip-left">
          </div>
          <!-- 2025-->
          <div class="position-relative mt-4">
            <div class="time-text-left w-100" data-aos="fade-right">
              <h3 class="text-purple mb-0">2025</h3>
              <h5 class="text-purple time-dot-right">2025/7</h5>
              <p class="text-gray">
                在美國取得專利授權<br>專利編號：US 12,361,756 B2<br>ARTIFICIAL INTELLIGENCE-ASSISTED EVALUATION METHOD FOR AESTHETIC MEDICINE AND EVALUATION SYSTEM USING SAME
              </p>
            </div>
            <img id="img2025" class="mt-3" src="./../assets/images/US12361756B2.jpg" data-aos="flip-left" style="width: 100%;">
          </div>

          <!-- 2026 China (文右圖左) -->
          <div class="position-relative mt-4 timeline-item is-right-text">
            <h3 class="text-purple text-start mb-0" data-aos="fade-left">2026</h3>
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">2026/2</h5>
            <p class="text-gray text-start mb-4" data-aos="fade-left">
              在中國取得專利授權<br>專利編號：ZL 2022 1 0051288.X
            </p>
            <img id="img2026" class="shadow-sm timeline-img is-left border" src="./../assets/images/ZL202210051288.X.png" data-aos="flip-left">
          </div>

          <!-- 2026 US (文右圖左) -->
          <div class="position-relative mt-4 timeline-item is-right-text">
            <h5 class="text-purple text-start time-dot-left" data-aos="fade-left">2026/2</h5>
            <p class="text-gray text-start" data-aos="fade-left">
              {{ $t('2026_us_title') }}<br>{{ $t('2026_us_no') }}<br>{{ $t('2026_us_inventor') }}<br>{{ $t('2026_us_en_title1') }}<br>{{ $t('2026_us_en_title2') }}
            </p>
            <img id="img2026_us" class="shadow-sm timeline-img is-left border" src="./../assets/images/US12536663B2.png" data-aos="flip-left">
          </div>



        </div>
      </div>
    </div>
    <div class="img-with-text">
      <img id="img2" src="./../assets/images/about_4.png">
      <div id="text2" class="text-on-img text-start" data-aos="fade-right">
        <h3 class="text-white mb-4">{{ $t('omnifirst1') }}</h3>
        <p class="text-white">{{ $t('omnifirst2') }}</p>
        <h5 class="text-white">{{ $t('omnifirst3') }}</h5>
        <h5 class="text-white">{{ $t('omnifirst4') }}</h5>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Footer
  },
  mounted () {
    document.title = this.$t('about') + ' - OMNIcounsel'
  }
}
</script>

<style lang="scss">
@import '@/scss/theme.scss';
@import url('https://fonts.googleapis.com/css2?family=Source+Serif+Pro:wght@600&display=swap');

#about {
  .img-with-text{
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  .text-on-img{
    position: absolute
  }
  .ptob {
    background: linear-gradient(to right, $purple-two, $light-blue);
    h2 {
      font-weight: 400;
    }
  }
  .btob {
    background: linear-gradient(340deg, $light-blue, white 10%, white 90%, $light-blue);
  }
  .logo-w {
    @include media-pad {
      width: 50%;
    }
  }

  #text1 {
    top: 36%;
    left: 15%;
    width: 30%;
    @include media-pad {
      top: 25%;
      left: 10%;
      width: 60%;
      h3 {
        font-size: 1.5rem;
        margin-bottom: 1rem !important;
      }
    }
    @include media-mobile {
      top: 15%;
      left: 5%;
      width: 80%;
      h3 {
        font-size: 1.2rem;
        margin-bottom: 0.5rem !important;
      }
      p {
        font-size: 0.8rem;
        line-height: 1.4;
      }
    }
  }

  #history {
    h3, h5 {
      font-family: 'Source Serif Pro', serif;
    }
    h5 {
      margin-top: 1rem;
    }
  }

  .vline {
    border-image: linear-gradient($purple-two, $light-blue) 30 30;
    border-left: 3px solid;
  }

  .time-dot-left {
    position: relative;
    &:before {
      position: absolute;
      content: "";
      border-top: 2px solid $purple;
      width: 2.5rem;
      left: -50px;
      top: 12px;
    }
    &:after {
      position: absolute;
      content: "";
      background-color: $purple;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      left: -54px;
      top: 9px;
    }
  }
  /* 修改 .time-dot-right 確保點精準對齊 border-left 的位置 */
  .time-dot-right {
    position: relative;
    &:before {
      position: absolute;
      content: "";
      border-top: 2px solid $purple;
      /* 這裡的寬度要等於父層 ps-5 的距離 (約 48px) */
      width: 48px; 
      right: -48px;
      top: 12px;
    }
    &:after {
      position: absolute;
      content: "";
      background-color: $purple;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      /* -48px 到達線邊緣，再 -4px 讓圓心落在線上 (半徑) */
      right: -52px; 
      top: 9px;
      z-index: 1;
    }
    
    @include media-pad {
      &:before {
        left: -50px;
        right: auto;
      }
      &:after {
        left: -54px;
        right: auto;
      }
    }
  }

  /* 針對 2025 圖片的寬度調整，使其與 2021 圖片樣式統一 */
  #img2025 {
    width: 100%;
    max-width: 500px; /* 限制最大寬度避免過大 */
    @include media-pad {
      width: 80%;
    }
  }

  .time-img-left {
    position: absolute;
    right: 120%;
    @include media-pad {
      position: relative;
      right: auto;
    }
  }
  .time-text-left {
    position: absolute;
    right: 42vw;
    text-align: end;
    p {
      text-align: end;
    }
    @include media-pad {
      position: relative;
      right: auto;
      text-align: start;
      p {
        text-align: start;
      }
    }
  }

  #img2016 {
    top: 58%;
    height: 100%;
    @include media-pad {
      top: auto;
      width: 80%;
      height: auto;
    }
  }
  #img2018 {
    top: 32%;
    height: 70%;
    @include media-pad {
      top: auto;
      width: 80%;
      height: auto;
    }
  }
  #img2019_1 {
    width: 60%;
    @include media-pad {
      width: 80%;
    }
  }
  #img2019_2 {
    width: 90%;
    @include media-pad {
      width: 80%;
    }
  }
  #img2020_1 {
    top: 20%;
    height: 80%;
    @include media-pad {
      top: auto;
      width: 80%;
      height: auto;
    }
  }
  #img2020_2 {
    top: 2%;
    height: 80%;
    @include media-pad {
      top: auto;
      width: 80%;
      height: auto;
    }
  }
  #img2021 {
    width: 100%;
    @include media-pad {
      width: 80%;
    }
  }
  #img2 {
    width: 100%;
    @include media-pad {
      width: 200%;
    }
  }
  #text2 {
    top: 36%;
    left: 15%;
    width: 30%;
    @include media-pad {
      width: 50%;
    }
    @include media-pad {
      width: 65%;
      top: 8%;
      left: 20%;
    }
  }
  // ==========================
  // 2022 / 2025 / 2026 專利區塊：參考 2021 樣式（點永遠鎖在藍線上）
  // ==========================

  $line-offset-from-text: 48px;  // ps-5 = 48px（文字起點到藍線）
  $timeline-gap: 60px;           // 藍線到左側內容的基準距離

  // ✅ 只推「內容」更往左：2022/2026 左圖、2025 左文
  $patent-img-extra-left: 32px;  // 2022/2026 圖再往左（可調：24/32/40）
  $patent-text-extra-left: 32px; // 2025 文再往左（可調：24/32/40）

  .timeline-item {
    position: relative;

    @include media-pc {
      padding-top: 8px;
      padding-bottom: 32px;
      min-height: 400px;
    }

    @include media-pad {
      padding-bottom: 16px;
      min-height: auto;
    }
  }

  .timeline-item.is-double {
    @include media-pc {
      min-height: 850px;
    }
  }

  // 圖片通用
  .timeline-img {
    border: 1px solid #f0f0f0;

    @include media-pc {
      width: 280px;
      height: auto;
      display: block;
    }

    @include media-pad {
      width: 90%;
      max-width: 400px;
      margin: 1.5rem auto 0;
      display: block;
      position: relative !important;
      left: auto !important;
      right: auto !important;
      top: auto !important;
    }
  }

  // --------------------------
  // 2022 / 2026：文右圖左（點鎖藍線，圖往左推）
  // --------------------------
  .timeline-item.is-right-text {
    .timeline-img.is-left {
      @include media-pc {
        position: absolute;
        right: calc(100% + #{$timeline-gap} + #{$patent-img-extra-left}); // ✅ 左圖再往左
        top: 0;
      }
    }

    // 點點鎖藍線 + 線段由藍線往右指向文字（參考原本 time-dot-left）
    .time-dot-left {
      position: relative;

      &:before {
        position: absolute;
        content: "";
        border-top: 2px solid $purple;
        width: $line-offset-from-text;
        left: -$line-offset-from-text; // 線段左端落在藍線
        top: 12px;
      }

      &:after {
        position: absolute;
        content: "";
        background-color: $purple;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        left: calc(-#{$line-offset-from-text} - 4px); // ✅ 點中心鎖在藍線
        top: 9px;
      }
    }
  }

  // --------------------------
  // 2025：文左圖右（點鎖藍線，線由藍線往左指向文字）
  // --------------------------
  .timeline-item.is-left-text {
    .time-text-leftside {
      @include media-pc {
        position: absolute;
        right: calc(100% + #{$timeline-gap} + #{$patent-text-extra-left}); // ✅ 左文再往左
        top: 0;
        width: 320px;
        text-align: end;

        p { text-align: end; }
      }

      @include media-pad {
        position: relative;
        right: auto;
        top: auto;
        width: auto;
        text-align: start;

        p { text-align: start; }
      }
    }

    // ✅ 2025：點永遠在藍線上（不再推點）
    // 線段長度 = 左文字離藍線的距離
    .time-dot-line-left {
      position: relative;

      $gap-to-line: calc(#{$timeline-gap} + #{$patent-text-extra-left});

      &:before {
        position: absolute;
        content: "";
        border-top: 2px solid $purple;

        width: $gap-to-line;
        right: calc(0px - #{$gap-to-line}); // ✅ Sass 安全：用 calc 做負號
        top: 12px;
      }

      &:after {
        position: absolute;
        content: "";
        background-color: $purple;
        width: 8px;
        height: 8px;
        border-radius: 50%;

        right: calc(0px - #{$gap-to-line} - 4px); // ✅ 點中心鎖在藍線
        top: 9px;
      }
    }


    // 2025 右側圖片：不要推到最右邊，維持跟右欄內容一致
    .timeline-img.is-right {
      @include media-pc {
        position: relative;
        margin-left: 0;
        margin-top: 12px;
        display: block;
      }
    }
  }

}
</style>
